__turbopack_context__.v({
  "calendarMonth": "P8JCcG_calendarMonth",
  "calendarWeek": "P8JCcG_calendarWeek",
  "calendarWeekDays": "P8JCcG_calendarWeekDays",
  "container": "P8JCcG_container",
  "shimmer": "P8JCcG_shimmer",
  "shimmerOverlay": "P8JCcG_shimmerOverlay",
});
